module.exports = __webpack_public_path__ + "img/up_arrow.6285bb51.svg";